import styled from 'styled-components';
export {
  FormRow,
  Button,
  LinkButton,
  ActivityIndicator,
  FormActions,
} from 'styles/components';

export const Container = styled.div`
  width: 100%;
`;

export const HelperText = styled.p`
  margin: -8px 0 16px;
  font-size: 13px;
  color: #64748b;
`;

export const Notice = styled.div`
  margin-top: 16px;
  padding: 12px 16px;
  border-radius: 8px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  color: #475569;
  font-size: 14px;
  line-height: 1.5;
`;
